export default "__VITE_ASSET__CP63Aor___"